import { cn } from '~/lib/utils'

const TwoThirds = ({
  children,
  className
}: {
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={cn(
        'space-y-l lg:space-y-xl col-span-1 lg:col-span-2',
        className
      )}
    >
      {children}
    </div>
  )
}

export default TwoThirds
